import "roboto-fontface/css/roboto/roboto-fontface.css";
import "font-awesome/css/font-awesome.css";
import '@mdi/font/css/materialdesignicons.css'
import './theme/default.styl'
import CKEditor from '@ckeditor/ckeditor5-vue2';
/*
import "../public/css/yo.css";
*/
import Vue from "vue";

import VeeValidate, {Validator} from "vee-validate";
import VueRouter from "vue-router";
import './stylus/main.styl'

import App from "./App";
import router from "./router";
import VueI18n from "vue-i18n";
import {store} from "./store";

import messages from "./lang";

import moment from "moment";
import VueCurrencyFilter from 'vue-currency-filter'
//require("bootstrap-datepicker");
import axios from "axios";
import {errorResponseHandler, requestHandler, successResponseHandler} from "./shared/response-handler";
import {dictionaries} from "./constants/langConstants";
//import "./plugins/vuetify";
import Vuetify from 'vuetify/lib';
import commonMixin from '@/mixins/commonMixin';

moment.locale("vi");

/*
import SockJS from "../public/plugin/sockjs/sockjs.min";
import Stomp from "../public/plugin/sockjs/stomp.min";
*/

window.$ = window.jQuery = require("jquery");
window.Vue = Vue;

axios.interceptors.request.use(requestHandler, function (error) {
  return Promise.reject(error);
});
axios.interceptors.response.use(successResponseHandler, errorResponseHandler);

/*let token = JSON.parse(
    localStorage.getItem("token") === "undefined"
        ? null
        : localStorage.getItem("token")
);
console.log(token);

if (token && token.access_token) {
    axios.defaults.headers.common["Authorization"] = "Bearer " + token.access_token;
}*/


let user = JSON.parse(
  localStorage.getItem("user") === "undefined"
    ? null
    : localStorage.getItem("user")
);
if (user && user.token) {
  axios.defaults.headers.common["Authorization"] = "Bearer " + user.token;
}


// todo
// cssVars()
Vue.use(VueI18n);
const i18n = new VueI18n({
  locale: store.getters.selectedLocale.locale,
  messages: messages,
  silentTranslationWarn: true
});

//import "./plugins/ruleValidator";

Vue.use(VeeValidate, {
  i18nRootKey: 'lang',
  i18n,
  fieldsBagName: "veeFields",
  dictionary: dictionaries
});

Vue.use(CKEditor);

Validator.extend("date_after_now", {
    validate(value) {
      try {
        let valid = moment(value).hour(23).minute(59).second(59).isSameOrAfter(new Date()); // false
        return valid;
      } catch (e) {
        console.log(e);
        return false;
      }
    },

    getMessage: field => {
      return field + " phải sau ngày hiện tại";
    },
  }
);

Validator.extend("date_before_now", {
    validate(value) {
      try {
        let valid = moment(value).hour(0).minute(0).second(0).isSameOrBefore(new Date()); // false
        return valid;
      } catch (e) {
        return false;
      }
    },

    getMessage: field => {
      return field + " phải trước ngày hiện tại";
    },
  }
);

Validator.extend("phone", {
    validate(value) {
      try {
        let phoneno = /^\d{5,11}$/;
        if (value.match(phoneno)) {
          return true;
        }

        return false;
      } catch (e) {
        return false;
      }
    },

    getMessage: field => {
      return field + " không phải là số điện thoại";
    },
  }
);


Vue.config.productionTip = false;
Vue.use(VueRouter);
//Vue.use(BootstrapVue);

Vue.component("data-table", require("./components/DataTable.vue").default); //component name should be in camel-case
Vue.component("gru-table", require("./components/GruTable.vue").default); //component name should be in camel-case
Vue.component('v-datetime-picker', require("./components/form/DatetimePicker.vue").default);
Vue.component('i-avatar', require("./components/form/Avatar.vue").default);
Vue.component('i-datepicker', require("./components/form/DatePicker.vue").default);
Vue.component('c-textbox-float', require("./components/form/TextboxFloat.vue").default);
Vue.component('c-input-number', require("./components/form/InputNumber.vue").default);


Vue.filter("capitalize", function (value) {
  if (!value) return "";
  value = value.toString();
  return value.charAt(0).toUpperCase() + value.slice(1);
});

Vue.filter('formatDateTime', function (value) {
  if (value) {
    return moment(String(value)).format(i18n.t("lang.common.dateTimeFormat"));
  }
});

Vue.filter('fromNow', function (value) {
  if (value) {
    return moment(String(value)).fromNow();
  }
});

Vue.filter('formatDate', function (value) {
  if (value) {
    return moment(String(value)).format(i18n.t("lang.common.dateFormat"))
  }
});

Vue.filter('formatTime', function (value) {
  if (value) {
    return moment(String(value)).format('hh:mm')
  }
});

Vue.filter('mathLatext', function (value) {
  if (value) {
    let html = MathJax.tex2chtml(value, {em: 12, ex: 6, display: false});
    let text = html.outerHTML;
    return text;
  } else {
    return null;
  }
});

Vue.use(VueCurrencyFilter,
  {
    symbol: '',
    thousandsSeparator: '.',
    fractionCount: 2,
    fractionSeparator: ',',
    symbolPosition: 'front',
    symbolSpacing: true,
    avoidEmptyDecimals:undefined
  });

const vueConfig = require("vue-config");
let dtSetting = {};
/*
console.log("--- token ---");
alert(token);
*/


const configs = {
  datetimeSetting: dtSetting
}

Vue.use(vueConfig, configs);

//console.log(messages);
Vue.use(Vuetify, {
  theme: {
    primary: '#02205D',
    secondary: '#424242',
    accent: '#82B1FF',
    error: '#E53935',
    info: '#2196F3',
    success: '#4CAF50',
    warning: '#FFC107',
    cancel: '#c1c1c1'
  },
  lang: {
    t: (key, ...params) => {
      //console.log(i18n);
      let label = i18n.t("lang." + key, params);
      return label;
    }
  },
  customProperties: true,
  iconfont: 'md' || 'mdi',
})

Vue.mixin({
  methods: {
    formatNumber: function (n) {
      let num = '';
      if (n != undefined) {
        num = n.toFixed( (/\./g.test(n))?2:0 ).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");
      }
      return num;
    },
  },
})

new Vue({
  //el: "#app",
  router,
  store,
  i18n,
  template: "<App/>",
  render: h => h(App),
  components:
    {
      App
    }
}).$mount("#app");
